// PreviousRouteContext.js
import { createContext, useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const PreviousRouteContext = createContext(null);

export const PreviousRouteProvider = ({ children }) => {
  const location = useLocation();
  const prevLocationRef = useRef(null);
  const [previousRoute, setPreviousRoute] = useState(null);

  useEffect(() => {
    // Every time location changes, we save the previous one in the state
    setPreviousRoute(prevLocationRef.current);
    // We update the ref to the current route
    prevLocationRef.current = location.pathname;
  }, [location]);

  // eslint-disable-next-line react/react-in-jsx-scope
  return <PreviousRouteContext.Provider value={{ previousRoute, setPreviousRoute }}>{children}</PreviousRouteContext.Provider>;
};
